import React, { Component } from 'react';
import { connect } from 'react-redux';
import { searchSite } from '../actions';
import { Global_ISDA_Functions } from 'Root/global/global';

global.isdaMegamenuResults = document.getElementById( 'megamenu-search-wrap' );
global.isdaFetchingResults = false;

class SearchResults extends Component {
	constructor() {
		super();

		// Init a timeout variable for keyup search
		this.searchTimeOut = null;
	}

	componentDidMount() {
		if ( global.isdaMegamenuResults.classList ) {
			global.isdaMegamenuResults.classList.add( 'loaded' );
		} else {
			global.isdaMegamenuResults.className += ' ' + 'loaded';
		}
	}

	componentWillUpdate( nextProps ) {
		let self = this,
		    newProps = nextProps,
		    prevChange            = self.props.changeNumber,
		    updatedChange         = newProps.changeNumber;

		if ( newProps.searchTerm.length < 3 ) {
			return;
		}

		if ( updatedChange > prevChange ) {
			if ( self.props.searchTerm !== newProps.searchTerm ) {
				global.isdaFetchingResults = true;
				setTimeout( function() {
					self.props.searchSite(  newProps.searchTerm  );
				}, 800 );
			}
		}
	}

	componentDidUpdate() {
		// Clear the timeout if it has already been set.
		// This will prevent the previous task from executing
		// if it has been less than <MILLISECONDS>
		clearTimeout( this.searchTimeOut );

		if ( this.props.searchTerm ) {
			global.isdaFetchingResults = false;
		}
	}

	displayIcon( icon_val, count ) {
		if ( icon_val && count === 4 ) {
			return (
				<span className={ 'category-icon category-' + icon_val + '-dark' } aria-hidden="true">&nbsp;</span>
			);
		} else if ( icon_val ) {
			return (
				<span className={ 'category-icon category-' + icon_val } aria-hidden="true">&nbsp;</span>
			);
		}

		return (
			<span>&nbsp;</span>
		);
	}

	renderResults( searchResults ) {
		let count = 0;
		return searchResults.map( result => {
			count += 1;
			return (
				<div key={ result.id } className={ ( result.prioritized
						? 'prioritized col-sm-6 col-lg-3'
						: 'col-sm-6 col-lg-3'
				) }>
					<a href={ result.link }>
						<article className="excerpt-small">
							<h2 className="entry-title" dangerouslySetInnerHTML={ {__html: result.title } } />
							{ this.displayIcon( result.icon, count ) }
						</article>
					</a>
				</div>
			);
		} );
	}

	render() {
		let globalIsdaFunctions = new Global_ISDA_Functions(),
		    loadedState         = globalIsdaFunctions.vanillaHasClass( global.isdaMegamenuResults, 'loaded' ),
		    searchTerm          = this.props.searchTerm;

		if ( loadedState === true && this.props.results.length > 0 ) {
			return (<div className="row">
					{ this.renderResults( this.props.results ) }
				</div>
			);
		} else if ( loadedState === true && searchTerm.length > 0 && this.props.results.length === 0 && !global.isdaFetchingResults ) {
			return (<div className="row">
					{/*<p className="col-xs-12">No results found within the last 6 months. To search older results, proceed to the Search Results Page.</p>*/}
				</div>
			);
		} else if ( loadedState === true && searchTerm.length > 0 && this.props.results.length === 0 && global.isdaFetchingResults ) {
			return (<div className="row">
					<img className="search-fetching-icon" src={ ISDA_Main.ajaxLoader } alt="Fetching results..." />
				</div>
			);
		}

		//if nothing has loaded yet
		return (<div className="row">
			</div>
		);

	}
}

function mapStateToProps( { results, searchTerm, changeNumber } ) {
	return { results, searchTerm, changeNumber };
}

export default connect( mapStateToProps, { searchSite } )( SearchResults );